import { AlertTriangle } from 'lucide-react';

export default function ManualSelectionsBanner() {
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 mb-6">
      <div className="flex items-center gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0" />
        <p className="text-sm text-amber-800">
          <span className="font-medium">Manual Action Required:</span>{' '}
          These items need a recruiter to act manually — the system will not auto-progress them.
        </p>
      </div>
    </div>
  );
}
